<style lang="less" scoped>
  .subway-container {
    background-color: #eaeafb;
  }
  .in-sec {
    width: 1200px; margin: 0 auto;
    height: 800px; position: relative;
  }
  h2 {
    font-size: 54px; color: #1170fe;
    padding-top: 112px; position: relative; z-index: 1;
    span {
      display: block; font-size: 20px; font-family: 'NotoSansKR_L';
      color: #222224; padding-top: 9px;
    }
  }
  .list {
    position: absolute; right: 0; text-align: center;
    h3 {
      background-color: #fff; padding: 12px; border-radius: 10px;
      text-align: center; box-shadow: 0 10px 46px rgba(0, 0, 0, .01);
      display: inline-block; margin: 0 auto;
      span {
        background-color: #637594; color: #fff; display: block;
        font-size: 20px; font-family: 'NotoSansKR_L'; width: 166px;
        padding: 29px 0;
        strong {
          color: #fef50a; display: block;
          font-size: 28px; padding-top: 3px;
        }
      }
    }
    ul {
      overflow: hidden; width: 318px; background: url('~@/assets/line-3.png') no-repeat center 0;
      padding-top: 76px; margin-top: 11px;
      i {
        display: block; width: 60px; height: 60px; margin: 0 auto 10px;
        background-color: #fff; border-radius: 15px;
        &::after {
          content: ''; width: 60px; height: 60px; display: block;
        }
        &.icon-7:after { background: url('~@/assets/icon-7.png') no-repeat; }
        &.icon-8:after { background: url('~@/assets/icon-8.png') no-repeat; }
        &.icon-9:after { background: url('~@/assets/icon-9.png') no-repeat; }
        &.icon-10:after { background: url('~@/assets/icon-10.png') no-repeat; }
        &.icon-11:after { background: url('~@/assets/icon-11.png') no-repeat; }
        &.icon-12:after { background: url('~@/assets/icon-12.png') no-repeat; }
        &.icon-13:after { background: url('~@/assets/icon-13.png') no-repeat; }
        &.icon-14:after { background: url('~@/assets/icon-14.png') no-repeat; }
        &.icon-15:after { background: url('~@/assets/icon-15.png') no-repeat; }
      }
      li {
        width: 106px; float: left; font-size: 15px; padding-bottom: 22px;
      }
    }
  }
  .subway {
    position: absolute; top: 286px; left: 196px; z-index: 1;
    width: 658px; height: 451px; background: url(~@/assets/car-3-1.png) no-repeat;
  }
  .building {
    position: absolute; top: 132px; left: 493px; z-index: 1;
    width: 141px; height: 224px; background: url(~@/assets/building-5.png) no-repeat;
  }
  .bench {
    position: absolute; top: 273px; left: 586px; z-index: 1;
    width: 196px; height: 159px; background: url(~@/assets/bench-1.png) no-repeat;
  }

  .animate-1 { transition-delay: .3s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-2 { transition-delay: .4s; transition-duration: .25s; transition-timing-function: ease-out; }
  .animate-3 { transition-delay: .8s; transition-duration: .4s; transition-timing-function: ease-in; }

  .slide-down {
    opacity: 0;
    transform: translateY(-50px);
  }
  .slide-down.animate-active {
    opacity: 1;
    transform: translateY(0);
  }

  .slide-car {
    opacity: 0;
    transform: translate(-150px,-50px);
  }
  .slide-car.animate-active {
    opacity: 1;
    transform: translate(0,0);
  }

  @media only screen and (max-width: 768px) {
    .in-sec {
      width: auto; height: 460px;
    }
    h2 {
      position: absolute; right: 0; padding-top: 55px;
      font-size: 27px; width: 186px; text-align: center;
      span {
        font-size: 11px;
      }
    }
    .list {
      position: absolute; right: 10px; text-align: center; top: 128px;
      h3 {
        background-color: #fff; padding: 6px; border-radius: 5px;
        text-align: center; box-shadow: 0 10px 46px rgba(0, 0, 0, .01);
        display: inline-block; margin: 0 auto;
        span {
          background-color: #637594; color: #fff; display: block;
          font-size: 11px; font-family: 'NotoSansKR_L'; width: 84px;
          padding: 15px 0;
          strong {
            color: #fef50a; display: block;
            font-size: 14px; padding-top: 3px;
          }
        }
      }
      ul {
        overflow: hidden; width: 180px;
        background: url('~@/assets/line-3.png') no-repeat center 0;
        background-size: 60% auto;
        padding-top: 36px; margin-top: 5px;
        i {
          width: 30px; height: 30px; margin: 0 auto 5px;
          background-color: #fff; border-radius: 6px;
          &::after {
            width: 30px; height: 30px;
          }
          &.icon-7:after { background-size: cover; }
          &.icon-8:after { background-size: cover; }
          &.icon-9:after { background-size: cover; }
          &.icon-10:after { background-size: cover; }
          &.icon-11:after { background-size: cover; }
          &.icon-12:after { background-size: cover; }
          &.icon-13:after { background-size: cover; }
          &.icon-14:after { background-size: cover; }
          &.icon-15:after { background-size: cover; }
        }
        li {
          width: 60px; font-size: 10px; padding-bottom: 22px;
        }
      }
    }
    .subway {
      top: 90px; left: -30px;
      width: 250px; height: 171px;
      background-size: cover;
    }
    .building {
      top: 10px; left: 80px;
      width: 70px; height: 111px;
      background-size: cover;
    }
    .bench {
      top: 87px; left: 126px;
      width: 80px; height: 65px;
      background-size: cover;
    }
  }
</style>

<template lang="pug">
  .subway-container
    .in-sec
      h2 지하철 팝 #[span 철도 통합정보 제공]
      .subway.animate-3.slide-car(data-aos="fade")
      .building.animate-1.slide-down(data-aos="fade-in")
      .bench.animate-2.slide-down(data-aos="fade-in")
      .list
        h3 #[span 스마트역사#[strong IoT HUB]]
        ul
          li #[i.icon-7] CCTV
          li #[i.icon-8] 승강기제어
          li #[i.icon-9] 휠체어리프트
          li #[i.icon-10] 역사방송
          li #[i.icon-11] 셔터문 제어
          li #[i.icon-12] 비상전화
          li #[i.icon-13] 공조설비
          li #[i.icon-14] 비상게이트
          li #[i.icon-15] 장애인화장실
      media(:mediaData="subway")
</template>

<script>
import Media from '@/components/Media.vue';

export default {
  props: {
    subway: {
      type: Object,
      default: null,
    },
  },
  components: {
    Media,
  },
};
</script>
